export default __webpack_public_path__ + "static/media/Group 1171276208 (3).e2dd6968.svg";